export function downloadVCard(card) {
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${card.lastName || ""};${card.firstName || ""};;;`,
    `FN:${card.name || ""}`,
    card.company ? `ORG:${card.company}` : "",
    card.title ? `TITLE:${card.title}` : "",
    card.phone ? `TEL;TYPE=CELL,VOICE:${card.phone}` : "",
    card.whatsapp ? `TEL;TYPE=CELL,MSG:${card.whatsapp}` : "",
    card.email ? `EMAIL;TYPE=INTERNET:${card.email}` : "",
    card.enquiryEmail ? `EMAIL;TYPE=INTERNET,WORK:${card.enquiryEmail}` : "",
    card.website ? `URL:${card.website}` : "",
    card.whatsapp ? `X-SOCIALPROFILE;TYPE=whatsapp:https://wa.me/${card.whatsapp.replace(/[^0-9]/g, "")}` : "",
    card.location ? `ADR;TYPE=WORK:;;${card.location};;;;` : "",
    "END:VCARD",
  ].filter(Boolean);

  const blob = new Blob([lines.join("\r\n")], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(card.name || "contact").replace(/\s+/g, "_")}.vcf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
